import React from "react";
import NewPAOffersPage from "./components/NewPAOffersPage";

const NewPreapproveOffersPage = () => {

  return (
    <div className={"form-signin-container pt-0"}>
      <NewPAOffersPage />
    </div>
  );
};

export default NewPreapproveOffersPage;
